export default __webpack_public_path__ + "static/targeting-c1bca12e5ddbcc15b84c573e520d3b78.png";